<template>
	<div>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>缺陷筛查</el-breadcrumb-item>
			<el-breadcrumb-item>工单查询</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="form-bar">
			<el-form :inline="true">
				<el-form-item label="时间范围">
					<DateRange v-model="dateRange" />
				</el-form-item>
				<el-form-item label="车间选择">
					<el-select v-model="workshop" clearable placeholder="车间选择">
						<el-option v-for="item in workshops" :key="item.value" :label="item.label" :value="item.value"> </el-option>
					</el-select>
				</el-form-item>

				<el-form-item>
					<el-button type="primary" @click="query">工单查询</el-button>
				</el-form-item>
			</el-form>
		</div>

		<div>
			<el-table  border ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
			row-key="_id.$oid"
			v-loading="tableLoading" 		
    		:tree-props="{children: 'children', hasChildren: 'hasChildren'}">
				<!-- <el-table-column type="index" width="60" label="序号"> </el-table-column> -->
				<el-table-column prop="product_name" label="产品名称"></el-table-column>
				<el-table-column prop="roll_code" label="批次号" width="120"> </el-table-column>
				<el-table-column prop="jt_name" label="机台" width="120"> </el-table-column>
				<el-table-column prop="job_order_id" label="工单号" width="80"> </el-table-column>
				<el-table-column prop="status" label="批次状态" width="80"> </el-table-column>
				<el-table-column prop="filter_status" label="筛选状态" width="80"> </el-table-column>
				<el-table-column prop="Insp_count" label="检测张数" width="80"> </el-table-column>
				<el-table-column prop="bad_count" label="坏品张数" width="80"> </el-table-column>
				<el-table-column prop="total_len" label="总长度" width="100"> </el-table-column>
				<el-table-column prop="total_def_count" label="缺陷个数" width="80"> </el-table-column>
				<el-table-column prop="total_bad_count" label="坏品个数" width="80"> </el-table-column>
			
				<el-table-column label="工艺信息" width="100">
					<template>
						<router-link :to="{name: 'DefectOrdersCraftInfo'}">查看</router-link>
					</template>
				</el-table-column>
				<el-table-column label="颜色信息" width="100">
					<template>
						<router-link :to="{name: 'DefectOrdersColorInfo'}">查看</router-link>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
	import DateRange from '@/components/DateRangePicker'
	// import { jobOrderRequest } from '../../network/requests/jobOrder'
	import dictionaryData from '@/service/dictionaryData'
	import jobOrderService from '../../service/jobOrderService'
	export default {
		components: {
			DateRange,
		},
		data() {
			return {
				jt_id:'',
				workshop: {},
				workshops: [],
				worksheet: {},
				dateRange: [],
				tableData: [
					{
						date: '2016-05-02',
						name: '王小虎',
						address: '上海市普陀区金沙江路 1518 弄',
					},
					{
						date: '2016-05-04',
						name: '王小虎',
						address: '上海市普陀区金沙江路 1517 弄',
					},
					{
						date: '2016-05-01',
						name: '王小虎',
						address: '上海市普陀区金沙江路 1519 弄',
					},
					{
						date: '2016-05-03',
						name: '王小虎',
						address: '上海市普陀区金沙江路 1516 弄',
					},
				],
			}
		},
		methods: {
			async query() {
				var filter
				console.log(this.dateRange)
				this.dateRange!=null&&this.dateRange.length===2? filter = {"start_time":{$gte:{ "$date": new Date(this.dateRange[0]).getTime()},$lte:{ "$date": new Date(this.dateRange[1]).getTime()}}} : filter
				this.jt_id != ''?filter.jt_id=this.jt_id:filter
				console.log("in methods query, local var filter is:", filter);
				var result = await jobOrderService.getJobOrderList(this.pageIndex, this.pageSize,filter)
				console.log("in methods query, local var result is ", result);
				this.tableData = result.data
				// this.tableData.forEach(function(v){v.hasChildren = true;})
				console.log(this.tableData)
				this.totalPage = result.totalPage
				this.tableLoading = false
			},
			showDetails() {
				this.$router.push({name: 'CraftView'})
			},
		},
		async created() {
			this.tableLoading = true
			this.query()
			this.workshops = await dictionaryData.getWorkshops()
		},
		watch: {
			workshop(val) {
				this.jt_list = this.jt_data.filter(t => t.workshop == val)
				if (this.jt_list.length > 0) {
					this.jt_id = this.jt_list[0].value
				} else {
					this.jt_id = ''
				}
			},
		},
	}
</script>

<style></style>
